<template>
  <div>
    <multiselect
      name="user_role"
      v-model="selectedCity"
      :options="cities"
      @input="updateSelected"
      placeholder="Все города"
      track-by="name"
      label="name"
      :showLabels="false"
      :searchable="false"
      :multiple="true">
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  props: ['updateSelectedCity'],
  computed: {
    $AllCities() {
      return this.$store.getters['platform/cities'];
      // cities[0] = {
      //   name: 'Почта',
      //   id: 0
      // };
      // return Object.values(cities);
    },
  },
  components: {
    Multiselect
  },
  data() {
    return {
      cities: [],
      selectedCity: []
    }
  },
  mounted() {
    const cities = Object.values(this.$AllCities);
    this.cities.push(cities.find((c) => c.id === 1));
    this.cities.push(cities.find((c) => c.id === 2));
    this.cities.push({id: 0, name: 'Почта'});
    const arr = cities.filter((c) => ![1, 2].includes(c.id));
    this.cities = [...this.cities, ..._.orderBy(arr, 'name')];
  },
  methods: {
    updateSelected(e) {
      if (this.updateSelectedCity) {
        this.updateSelectedCity(e);
      }
    }
  }
}

</script>
